import React, { useState, useEffect } from "react";
import { Row, Form, Button, Accordion, Card, Dropdown } from "react-bootstrap";
import { MdDoneAll } from "react-icons/md";
import CouponSelector from "../../components/CouponSelector/index";
import STRINGS from "../../constants/strings";
import {
  getShippingCharges,
  getAddressObjectFromAddressComponents,
  getCurrentLocation,
  validateAddress,
  validateUserAttributes,
  getShippingNumber,
  isOrderDeliverable,
  userHasAddress,
  object_equals,
} from "../../helper.js";
import Charges from "../Charges/index";
import ConfirmStorePickup from "./ConfirmStorePickup";
import STATES from "../../constants/states";
import InputMask from "react-input-mask";
import MapContainer from "../Maps/index";
import "./styles.scss";
import AddressAutoComplete from "../AddressAutoComplete";
import Geocode from "react-geocode";
import ToggleButton from "../ToggleButton/index";
import LoadingModal from "../LoadingModal";
import ProfileAddresses from "../ProfileAddresses";
import UpdateUserAddress from "../UpdateUserAddress";
import StorePickupOptions from "./StorePickupOptions";
import SelectableContext from "react-bootstrap/SelectableContext";
import GOOGLE_KEY from "../../config/maps";

Geocode.setApiKey(GOOGLE_KEY.KEY);

export default function HomeForm(props) {
  const {
    handleFormChange,
    username,
    email,
    given_name,
    loggedIn,
    codApplied,
    setCodApplied,
    shippingCharges,
    setShippingCharges,
    setIsStorePickup,
    isStorePickup,
    showAlert,
    placeOrder,
    isMobile,
    cartAmount,
    cart,
    addresses,
    handleChangeSavedAddress,
    handleUpdateUserAddresses,
    selectedStorePickupSlot,
    setSelectedStorePickupSlot,
    selectedStorePickupDate,
    setSelectedStorePickupDate,
    deliveryState,
  } = props;
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [enterNewAddress, setNewAddress] = useState(false);
  const [addressLine1Input, setAddressLine1] = useState(null);
  const [cityInput, setCityInput] = useState(null);
  const [stateInput, setStateInput] = useState(null);
  const [pincodeInput, setPincode] = useState(null);
  const [addressNameInput, setAddressNameInput] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [agreedToConditions, setAgreedToConditions] = useState(false);
  const [showConfirmStorePickup, setShowConfirmPickup] = useState(false);
  const [currentLocationInput, setCurrentLocationInput] = useState({
    lat: null,
    long: null,
  });
  const [houseNumberInput, setHouseNumberInput] = useState(null);
  const [alternateContactInput, setAlternateContactInput] = useState(null);
  const [selectedSavedAddressIndex, setSelectedSavedAddressIndex] = useState(0);
  const [addressUpdateType, setAddressUpdateType] = useState(-1);
  const [updateAddress, setUpdateAddress] = useState(null);
  const [contactPerson, setContactPerson] = useState(null);
  const selectedAddress =
    addresses.length > 0 ? addresses[selectedSavedAddressIndex] : {};

  useEffect(() => {
    (currentLocationInput.lat === null || currentLocationInput.long === null) &&
      !isStorePickup &&
      getCurrentLocation().then((coordinates) =>
        setCurrentLocationInput(coordinates)
      );
    if (loggedIn && addresses && addresses.length === 0) {
      setNewAddress(true);
    }
  }, [
    currentLocationInput.lat,
    currentLocationInput.long,
    enterNewAddress,
    addresses,
    loggedIn,
    isStorePickup,
  ]);

  const handleGetShippingCharges = () => {
    const requestAddress = enterNewAddress
      ? {
          addressLine1: addressLine1Input,
          city: cityInput,
          state: stateInput,
          pincode: pincodeInput,
          houseNumber: houseNumberInput,
          location: currentLocationInput,
        }
      : {
          addressLine1: selectedAddress.addressLine1,
          city: selectedAddress.city,
          state: selectedAddress.state,
          pincode: selectedAddress.pincode,
          houseNumber: selectedAddress.houseNumber,
          location: selectedAddress.location,
        };
    const user_attributes = {
      username: username,
      email,
      given_name,
    };
    const validAddressResult = validateAddress(requestAddress);
    const validateUserAttributesResult = validateUserAttributes(
      user_attributes
    );
    const isDeliverable = isOrderDeliverable(cart);

    if (
      validAddressResult === true &&
      validateUserAttributesResult === true &&
      isDeliverable
    ) {
      user_attributes.username = getShippingNumber(user_attributes.username);
      setShowLoadingModal(true);
      getShippingCharges({
        address: requestAddress,
        user_attributes,
        COD: codApplied ? 1 : 0,
        products: cart,
      })
        .then((result) => {
          showAlert(
            "Shipping Charges",
            `The shipping charges are ${result}`,
            true
          );
          setShippingCharges(Number(result));
          setShowLoadingModal(false);
        })
        .catch((error) => {
          showAlert("Shipping Charges", error.response.data.error);
          setShowLoadingModal(false);
        });
    } else {
      if (!isDeliverable) {
        showAlert(
          "Shipping Charges",
          "The cart contains some items such as (Trousseau Items) that are not eligible for Home Delivery. Please remove these products from cart and retry calculating shipping charges"
        );
      }
      if (validAddressResult.error) {
        showAlert("Shipping Charges", validAddressResult.error);
      } else if (validateUserAttributesResult.error) {
        showAlert("Shipping Charges", validateUserAttributesResult.error);
      }
    }
  };

  const getStateDropDown = () => (
    <SelectableContext.Provider value={false}>
      <Dropdown
        onChange={(event) => event.stopPropagation()}
        className="state-dropdown w-100"
      >
        <Dropdown.Toggle className="w-100 text-left">
          {enterNewAddress
            ? stateInput || "Choose State"
            : selectedAddress.state || "Choose State"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="state-dropdown-menu w-100">
          {STATES.map((element) => (
            <Dropdown.Item
              key={"state-" + element}
              eventKey={"state-" + element}
              onClick={(event) => {
                event.stopPropagation();
                enterNewAddress
                  ? setStateInput(element)
                  : handleChangeSavedAddress(
                      {
                        target: { value: element, name: "state" },
                      },
                      selectedSavedAddressIndex
                    );
              }}
              id={element}
            >
              {element}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </SelectableContext.Provider>
  );

  function setNewAddressFromMap(addressComponents, newLocation) {
    const parsedAddress = getAddressObjectFromAddressComponents(
      addressComponents
    );
    if (enterNewAddress) {
      setAddressLine1(parsedAddress.addressLine1);
      setCityInput(parsedAddress.city);
      setStateInput(parsedAddress.state);
      setPincode(parsedAddress.pincode);
      setCurrentLocationInput(newLocation);
    } else {
      handleChangeSavedAddress(
        {
          target: {
            name: "addressLine1",
            value: parsedAddress.addressLine1,
          },
        },
        selectedSavedAddressIndex
      );
      handleChangeSavedAddress(
        {
          target: {
            name: "city",
            value: parsedAddress.city,
          },
        },
        selectedSavedAddressIndex
      );
      handleChangeSavedAddress(
        {
          target: {
            name: "state",
            value: parsedAddress.state,
          },
        },
        selectedSavedAddressIndex
      );
      handleChangeSavedAddress(
        {
          target: {
            name: "pincode",
            value: parsedAddress.pincode,
          },
        },
        selectedSavedAddressIndex
      );
      handleChangeSavedAddress(
        {
          target: {
            name: "location",
            value: newLocation,
          },
        },
        selectedSavedAddressIndex
      );
    }
  }

  function getDeliveryOrStorePickupOptions() {
    if (!isStorePickup) {
      if (deliveryState) {
        return (
          <>
            {loggedIn && (
              <div className="mt-4">
                <ToggleButton
                  firstLabel="Saved Address"
                  secondLabel="New Address"
                  checkedValue={enterNewAddress}
                  handleOnChange={async () => setNewAddress(!enterNewAddress)}
                />
                {!enterNewAddress && (
                  <ProfileAddresses
                    addresses={addresses}
                    selectedSavedAddressIndex={selectedSavedAddressIndex}
                    setSelectedSavedAddressIndex={setSelectedSavedAddressIndex}
                    setAddressUpdateType={setAddressUpdateType}
                    setUpdateAddress={setUpdateAddress}
                  />
                )}
              </div>
            )}

            <div className="mt-4">
              <MapContainer
                currentLocation={
                  enterNewAddress
                    ? currentLocationInput
                    : selectedAddress.location || currentLocationInput
                }
                isMobile={isMobile}
                setCurrentLocationInput={(draggedLocation) =>
                  Geocode.fromLatLng(
                    draggedLocation.lat,
                    draggedLocation.long
                  ).then(
                    (response) =>
                      setNewAddressFromMap(
                        response.results[0].address_components,
                        draggedLocation
                      ),
                    (error) => {
                      console.error(error);
                    }
                  )
                }
              />
              <Form.Group>
                <AddressAutoComplete
                  addressInput={
                    enterNewAddress
                      ? addressLine1Input || ""
                      : selectedAddress.addressLine1 || ""
                  }
                  handleOnChange={(event) =>
                    enterNewAddress
                      ? setAddressLine1(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                  onSelectAddress={setNewAddressFromMap}
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="House/Flat/Block No"
                  value={
                    enterNewAddress
                      ? houseNumberInput || ""
                      : selectedAddress.houseNumber || ""
                  }
                  name="houseNumber"
                  onChange={(event) =>
                    enterNewAddress
                      ? setHouseNumberInput(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="City"
                  value={
                    enterNewAddress
                      ? cityInput || ""
                      : selectedAddress.city || ""
                  }
                  name="city"
                  onChange={(event) =>
                    enterNewAddress
                      ? setCityInput(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                />
              </Form.Group>
              <Form.Group>{getStateDropDown()}</Form.Group>
              <Form.Group>
                <InputMask
                  mask="999999"
                  maskChar={null}
                  placeholder="Pincode"
                  value={
                    enterNewAddress
                      ? pincodeInput || ""
                      : selectedAddress.pincode || ""
                  }
                  name="pincode"
                  onChange={(event) =>
                    enterNewAddress
                      ? setPincode(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                  className="form-control"
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Address Name (Optional)"
                  value={
                    enterNewAddress
                      ? addressNameInput || ""
                      : selectedAddress.addressName || ""
                  }
                  name="addressName"
                  onChange={(event) =>
                    enterNewAddress
                      ? setAddressNameInput(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                />
                <Form.Text className="text-muted">
                  Enter an address name
                </Form.Text>
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Contact Person Name (Optional)"
                  value={
                    enterNewAddress
                      ? contactPerson || ""
                      : selectedAddress.contactPerson || ""
                  }
                  name="contactPerson"
                  onChange={(event) =>
                    enterNewAddress
                      ? setContactPerson(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                />
              </Form.Group>
              <Form.Group>
                <InputMask
                  mask="+\919999999999"
                  maskChar={null}
                  placeholder="Contact Number for Delivery (Optional)"
                  value={
                    enterNewAddress
                      ? alternateContactInput || ""
                      : selectedAddress.alternateContact || ""
                  }
                  name="alternateContact"
                  onChange={(event) =>
                    enterNewAddress
                      ? setAlternateContactInput(event.target.value)
                      : handleChangeSavedAddress(
                          event,
                          selectedSavedAddressIndex
                        )
                  }
                  className="form-control"
                />
              </Form.Group>
            </div>
            <div className="d-flex mt-2 justify-content-center cal-shipping">
              <Button
                variant="outline-warning"
                className="landing-button text-nowrap"
                onClick={handleGetShippingCharges}
              >
                Check Shipping Charges
              </Button>
            </div>
          </>
        );
      } else {
        return (
          <p className="m-auto pt-3">
            All deliveries are suspended due to festive rush. Kindly place your
            order for Store Pickup and collect it from our store at a preferred
            date and time.
          </p>
        );
      }
    } else {
      return (
        <StorePickupOptions
          selectedStorePickupSlot={selectedStorePickupSlot}
          setSelectedStorePickupSlot={setSelectedStorePickupSlot}
          selectedStorePickupDate={selectedStorePickupDate}
          setSelectedStorePickupDate={setSelectedStorePickupDate}
        />
      );
    }
  }

  async function handleSubmit(address) {
    const validateUserAttributesResult = validateUserAttributes({
      username,
      email,
      given_name,
    });
    const validateAddressResult = validateAddress(address);
    const isDeliverable = isOrderDeliverable(cart);

    if (
      (validateAddressResult === true &&
        validateUserAttributesResult === true &&
        isDeliverable === true) ||
      isStorePickup
    ) {
      if (isStorePickup && !selectedStorePickupSlot) {
        return showAlert(
          "Store Pickup",
          "Please select the available delivery slots"
        );
      } else if (isStorePickup && selectedStorePickupSlot) {
        return placeOrder(address);
      }
      const cognitoAddress = Object.assign({}, address);
      Object.keys(cognitoAddress).forEach(
        (key) => cognitoAddress[key] === undefined && delete cognitoAddress[key]
      );
      if (loggedIn) {
        if (enterNewAddress) {
          if (!userHasAddress(cognitoAddress, addresses)) {
            setUpdateAddress(cognitoAddress);
            setAddressUpdateType(1);
          } else {
            placeOrder(cognitoAddress);
          }
        } else if (
          !enterNewAddress &&
          !object_equals(addresses[selectedSavedAddressIndex], cognitoAddress)
        ) {
          setUpdateAddress(cognitoAddress);
          setAddressUpdateType(2);
        } else {
          placeOrder(addresses[selectedSavedAddressIndex]);
          setAddressUpdateType(-1);
        }
      } else {
        placeOrder(address);
      }
    } else {
      if (validateAddressResult.error) {
        showAlert("Place Order", validateAddressResult.error);
      } else if (validateUserAttributesResult.error) {
        showAlert("Place Order", validateUserAttributesResult.error);
      }
      if (!isDeliverable && !isStorePickup) {
        showAlert(
          "Place Order",
          "The cart contains some items such as (Trousseau Items) that are not eligible for Home Delivery. Please remove these products from cart or select Store Pickup"
        );
      }
    }
  }

  return (
    <div className="w-100" id="home-form">
      <div className="heading text-center">
        <h2 className="text-capitalize">{STRINGS.DELIVERY_DETAILS}</h2>
      </div>

      <Form
        className="customer-form"
        onSubmit={(event) => {
          event.preventDefault();
          enterNewAddress
            ? handleSubmit({
                addressLine1: addressLine1Input,
                houseNumber: houseNumberInput,
                city: cityInput,
                state: stateInput,
                pincode: pincodeInput,
                location: currentLocationInput,
                alternateContact: alternateContactInput,
                addressName: addressNameInput,
                contactPerson,
              })
            : handleSubmit({
                addressLine1: selectedAddress.addressLine1,
                city: selectedAddress.city,
                state: selectedAddress.state,
                pincode: selectedAddress.pincode,
                houseNumber: selectedAddress.houseNumber,
                location: selectedAddress.location,
                alternateContact: selectedAddress.alternateContact,
                addressName: selectedAddress.addressName,
                contactPerson: selectedAddress.contactPerson,
              });
        }}
      >
        <div className="customer-form-background">
          <Form.Group>
            <Form.Control
              type="text"
              placeholder="Full Name"
              value={given_name || ""}
              name="given_name"
              onChange={handleFormChange}
              disabled={loggedIn}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="email"
              placeholder="Email Address"
              value={email || ""}
              name="email"
              onChange={handleFormChange}
              disabled={loggedIn}
            />
            <Form.Text className="text-muted">
              We'll never share your email with anyone else.
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <InputMask
              mask="+\919999999999"
              maskChar={null}
              placeholder="Username/Phone Number"
              value={username || ""}
              name="username"
              onChange={handleFormChange}
              disabled={loggedIn}
              className="form-control"
            />
            <Form.Text className="text-muted">
              Choose a number linked to Whatsapp, for Whatsapp Updates
            </Form.Text>
          </Form.Group>
          <Row className="d-flex justify-content-center w-100">
            <Accordion className="w-100">
              <Card>
                <Accordion.Toggle
                  className="d-flex justify-content-between text-capitalize"
                  as={Card.Header}
                  variant="link"
                  eventKey="0"
                >
                  <p>{STRINGS.APPLY_COUPON}</p>
                  {codApplied && (
                    <MdDoneAll
                      color="green"
                      size={25}
                      className="align-self-center"
                    />
                  )}
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <CouponSelector
                      coupon={coupon}
                      setCoupon={setCoupon}
                      validCoupon={codApplied}
                      setValidCoupon={setCodApplied}
                      showAlert={showAlert}
                      setShowLoadingModal={setShowLoadingModal}
                      isMobile={isMobile}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  variant="link"
                  className="d-flex justify-content-between text-capitalize"
                  eventKey="1"
                >
                  <p>{STRINGS.SELECT_DELIVERY}</p>
                  {shippingCharges && (
                    <p className="align-self-center">
                      Shipping Charges: {shippingCharges}
                    </p>
                  )}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <div
                      className={`d-flex ${
                        isMobile
                          ? "justify-content-between"
                          : "justify-content-around"
                      }`}
                    >
                      <div>
                        <Form.Check
                          label="Home Delivery"
                          type="radio"
                          checked={!isStorePickup}
                          onChange={() => {
                            isStorePickup && setIsStorePickup(false);
                            shippingCharges && setShippingCharges(null);
                            setSelectedStorePickupSlot(null);
                            setSelectedStorePickupDate(null);
                          }}
                        />
                      </div>
                      <Form.Check
                        label="Store Pickup"
                        type="radio"
                        feedback="Shipping Charges: Rs.0"
                        checked={isStorePickup}
                        onChange={() =>
                          codApplied
                            ? setIsStorePickup(true)
                            : setShowConfirmPickup(true)
                        }
                        isValid={isStorePickup}
                      />
                    </div>
                    {getDeliveryOrStorePickupOptions()}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Row>
          <Charges
            cartAmount={cartAmount}
            isMobile={isMobile}
            shippingCharges={shippingCharges}
            isStorePickup={isStorePickup}
            cartLength={cart.length}
            codApplied={codApplied}
          />
          <Row className="justify-content-center">
            <Form.Group className="pt-2">
              <Form.Check
                type="checkbox"
                disabled={!isStorePickup && !deliveryState}
                label="By clicking submit, I abide by Terms and Conditions, Privacy Policy and Refund policies"
                onChange={(event) =>
                  setAgreedToConditions(event.target.checked)
                }
              />
            </Form.Group>
          </Row>
          <div className="d-flex justify-content-center mt-4">
            <Button
              variant="outline-warning"
              className="w-50 landing-button h-100"
              type="submit"
              disabled={!agreedToConditions}
            >
              {STRINGS.SUBMIT}
            </Button>
          </div>
        </div>
      </Form>
      {showConfirmStorePickup && !codApplied && (
        <ConfirmStorePickup
          show={showConfirmStorePickup}
          setIsStorePickup={setIsStorePickup}
          closeModal={() => setShowConfirmPickup(false)}
          isMobile={isMobile}
          setShippingCharges={setShippingCharges}
        />
      )}
      {showLoadingModal ? <LoadingModal show={showLoadingModal} /> : null}
      {addressUpdateType >= 0 && (
        <UpdateUserAddress
          update={addressUpdateType}
          address={updateAddress}
          closeModal={() => setAddressUpdateType(-1)}
          isMobile={isMobile}
          placeOrder={placeOrder}
          handleUpdateUserAddresses={handleUpdateUserAddresses}
          selectedSavedAddressIndex={selectedSavedAddressIndex}
        />
      )}
    </div>
  );
}
